import { useEffect, useState } from "react";
import {
  Bot,
  Users,
  LayoutDashboard,
  LogIn,
  UserCircle2,
  UserPlus,
  Menu,
  X,
  CreditCard, // آیکون جدید برای پلن‌ها
} from "lucide-react";

export default function Header() {
  const [open, setOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const syncAuthState = () => {
      const hasUserId = !!sessionStorage.getItem("user_id");
      const hasProfile = !!sessionStorage.getItem("user_profile");
      setIsLoggedIn(hasUserId || hasProfile);
    };

    syncAuthState();
    window.addEventListener("storage", syncAuthState);
    window.addEventListener("focus", syncAuthState);

    return () => {
      window.removeEventListener("storage", syncAuthState);
      window.removeEventListener("focus", syncAuthState);
    };
  }, []);

  const authHref = isLoggedIn ? "/profile" : "/login";
  const authLabel = isLoggedIn ? "پروفایل" : "ورود";

  const handleAuthClick = (event) => {
    event.preventDefault();
    window.location.href = authHref;
  };

  return (
    <header
      dir="rtl"
      className="border-b border-white/10 bg-black/40 backdrop-blur sticky top-0 z-50"
    >
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">

        {/* LOGO */}
        <div className="flex items-center gap-3">
          <span className="font-semibold text-lg tracking-tight">
            دیپ‌ماین فایننس
          </span>
          <div className="h-9 w-9 rounded-lg bg-emerald-500/20 text-emerald-400 flex items-center justify-center font-bold">
            AI
          </div>
        </div>

        {/* DESKTOP NAV */}
        <nav className="hidden md:flex gap-8 text-sm text-slate-200">
          <a href="/dashboard" className="flex items-center gap-2 hover:text-emerald-400 transition">
            <LayoutDashboard size={16} />
            داشبورد
          </a>
          <a href="/mentors" className="flex items-center gap-2 hover:text-emerald-400 transition">
            <Users size={16} />
            منتورها
          </a>
          <a href="/chat" className="flex items-center gap-2 hover:text-emerald-400 transition">
            <Bot size={16} />
            چت هوش مصنوعی
          </a>
          {/* لینک جدید پلن‌ها */}
          <a href="/plans" className="flex items-center gap-2 hover:text-emerald-400 transition">
            <CreditCard size={16} />
            پلن‌ها
          </a>
        </nav>

        {/* ACTIONS */}
        <div className="hidden md:flex gap-3">
          <a
            href={authHref}
            onClick={handleAuthClick}
            className="flex items-center gap-2 px-4 py-2 border border-white/15 rounded-lg hover:border-emerald-400/40 transition text-sm"
          >
            {isLoggedIn ? <UserCircle2 size={16} /> : <LogIn size={16} />}
            {authLabel}
          </a>
          <a
            href="/signup"
            className="flex items-center gap-2 px-4 py-2 bg-emerald-500 text-black rounded-lg font-medium hover:bg-emerald-400 transition text-sm"
          >
            <UserPlus size={16} />
            شروع رایگان
          </a>
        </div>

        {/* MOBILE BUTTON */}
        <button
          onClick={() => setOpen(!open)}
          className="md:hidden text-slate-200"
          aria-label="menu"
        >
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {/* MOBILE MENU */}
      {open && (
        <div className="md:hidden border-t border-white/10 bg-black/60 backdrop-blur">
          <nav className="flex flex-col px-6 py-4 gap-4 text-sm">
            <a href="/dashboard" className="flex items-center gap-2 hover:text-emerald-400">
              <LayoutDashboard size={16} />
              داشبورد
            </a>
            <a href="/mentors" className="flex items-center gap-2 hover:text-emerald-400">
              <Users size={16} />
              منتورها
            </a>
            <a href="/chat" className="flex items-center gap-2 hover:text-emerald-400">
              <Bot size={16} />
              چت هوش مصنوعی
            </a>
            {/* لینک پلن‌ها در موبایل */}
            <a href="/plans" className="flex items-center gap-2 hover:text-emerald-400">
              <CreditCard size={16} />
              پلن‌ها
            </a>

            <hr className="border-white/10 my-2" />

            <a
              href={authHref}
              onClick={(event) => {
                setOpen(false);
                handleAuthClick(event);
              }}
              className="flex items-center gap-2 hover:text-emerald-400"
            >
              {isLoggedIn ? <UserCircle2 size={16} /> : <LogIn size={16} />}
              {authLabel}
            </a>
            <a href="/signup" className="flex items-center gap-2 text-emerald-400 font-medium">
              <UserPlus size={16} />
              شروع رایگان
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}
